/**
 * Multimap is an immutable object that is intended for use wherever you want
 * to store multiple values by key and disallow mutation.
 */
export type Multimap<T> = { readonly [id: string]: readonly T[] };

/**
 * RWMultimap is a mutable version of Multimap
 */
export type RWMultimap<T> = { [id: string]: T[] };

export function multimapAdd<T>(multimap: Multimap<T>, key: string, value: T): Multimap<T> {
  const multimapCopy = { ...multimap };
  if (!multimapCopy[key]) {
    multimapCopy[key] = [];
  }
  multimapCopy[key] = [...multimapCopy[key], value];
  return multimapCopy;
}

export function multimapRemove<T>(multimap: Multimap<T>, key: string, value: T): Multimap<T> {
  const multimapCopy = { ...multimap };
  if (!multimapCopy[key]) {
    return multimapCopy;
  }
  multimapCopy[key] = multimapCopy[key].filter((v) => v !== value);
  return multimapCopy;
}

export function multimapFlatten<T>(multimap: Multimap<T>): T[] {
  return Object.values(multimap).flat();
}
